"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AdoOrgApi = require("./AdoOrgApi");
Object.keys(_AdoOrgApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AdoOrgApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AdoOrgApi[key];
    }
  });
});
var _ArtifactEnablementApi = require("./ArtifactEnablementApi");
Object.keys(_ArtifactEnablementApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactEnablementApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactEnablementApi[key];
    }
  });
});
var _ArtifactMappingExemptionApi = require("./ArtifactMappingExemptionApi");
Object.keys(_ArtifactMappingExemptionApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactMappingExemptionApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactMappingExemptionApi[key];
    }
  });
});
var _ArtifactsApi = require("./ArtifactsApi");
Object.keys(_ArtifactsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactsApi[key];
    }
  });
});
var _ArtifactTagsApi = require("./ArtifactTagsApi");
Object.keys(_ArtifactTagsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ArtifactTagsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ArtifactTagsApi[key];
    }
  });
});
var _AzureDevOpsApi = require("./AzureDevOpsApi");
Object.keys(_AzureDevOpsApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AzureDevOpsApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AzureDevOpsApi[key];
    }
  });
});
var _MicrosoftGraphApi = require("./MicrosoftGraphApi");
Object.keys(_MicrosoftGraphApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MicrosoftGraphApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MicrosoftGraphApi[key];
    }
  });
});
var _OwnershipApi = require("./OwnershipApi");
Object.keys(_OwnershipApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OwnershipApi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OwnershipApi[key];
    }
  });
});